export function lower(string) {
    return string.toLowerCase();
}
